


// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import Rightcontainer from "../Components/Rightcontainer";

// const Mywallet = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     hi: {
//       status: "खाता स्थिति",
//       verified: "सत्यापन पूरा हुआ",
//       deposit: "डिपॉजिट चिप्स",
//       winnings: "विनिंग चिप्स",
//       availablePlay: "खेलने के लिए उपलब्ध",
//       withdrawBal: "निकालने योग्य शेष",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
//     },
//     en: {
//       status: "Account Status",
//       verified: "Verification Completed",
//       deposit: "Deposit Chips",
//       winnings: "Winning Chips",
//       availablePlay: "Available for play",
//       withdrawBal: "Withdrawable balance",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "Your transactions are 100% secure and encrypted.",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
//   const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

//   return (
//     <div className="wallet-page-wrapper leftContainer mt-5 pt-5">
//       <div className="wallet-main-content">
        
//         {/* Verification Status Header */}
//         <div className="status-banner">
//           <div className="avatar-wrapper">
//              <img src="/avatarwallet.png" alt="user" className="status-avatar" />
//              <div className="plus-badge">+</div>
//           </div>
//           <div className="status-info">
//             <span className="status-label">{t.status}</span>
//             <h2 className="status-text">{t.verified}</h2>
//           </div>
//         </div>

//         {/* Deposit Card */}
//         <div className="balance-card deposit-card">
//           <div className="card-top-row">
//             <span className="card-title">{t.deposit}</span>
//             <div className="chip-icon">₹</div>
//           </div>
//           <div className="amount-display">₹{depositAmount}</div>
//           <div className="amount-subtext">{t.availablePlay}</div>
//           <Link to="/addcase" className="action-btn add-btn">
//             {t.add}
//           </Link>
//         </div>

//         {/* Winnings Card */}
//         <div className="balance-card winning-card">
//           <div className="card-top-row">
//             <span className="card-title">{t.winnings}</span>
//             <div className="chip-icon purple">₹</div>
//           </div>
//           <div className="amount-display">₹{winningAmount}</div>
//           <div className="amount-subtext">{t.withdrawBal}</div>
//           <Link to="/Withdrawopt" className="action-btn withdraw-btn">
//             {t.withdraw}
//           </Link>
//         </div>

//         <p className="secure-text-footer">{t.secure}</p>
//       </div>

//       <div className="rightContainer mobile-hide">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Mywallet;

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";
// import "../css/walletNew.css"; // Separate Modern CSS file

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      depositDesc: "यह चिप्स Win एवं Buy की गई चिप्स है इनसे सिर्फ गेम खेले जा सकते है, बैंक या UPI से निकाला नहीं जा सकता है",
      winningDesc: "यह चिप्स गेम से जीती हुई एवं रेफरल से कमाई हुई है, इन्हे बैंक या UPI में निकाला जा सकता है, इन चिप्स से गेम भी खेला जा सकता है",
      add: "Add Cash",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
      totalBalance: "कुल वॉलेट बैलेंस",
      chipsLabel: "Chips",
      winningCashLabel: "Winning Cash"
    },
    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      depositDesc: "यह चिप्स Win एवं Buy की गई चिप्स है इनसे सिर्फ गेम खेले जा सकते है, बैंक या UPI से निकाला नहीं जा सकता है",
      winningDesc: "यह चिप्स गेम से जीती हुई एवं रेफरल से कमाई हुई है, इन्हे बैंक या UPI में निकाला जा सकता है, इन चिप्स से गेम भी खेला जा सकता है",
      add: "Add Cash",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
      totalBalance: "Total Wallet Balance",
      chipsLabel: "Chips",
      winningCashLabel: "Winning Cash"
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user ? Number(user.Wallet_balance - user.withdrawAmount || 0).toFixed(2) : "0.00";
  const winningAmount = user ? Number(user.withdrawAmount || 0).toFixed(2) : "0.00";
  const totalBalance = user ? Number(user.Wallet_balance || 0).toFixed(2) : "0.00";

  return (
    <div className="wallet-page-layout mt-5 pt-5">
      {/* Main Left Content Area */}
      <div className="wallet-main-container">
        
        {/* Balance Cards Stack */}
        <div className="wallet-cards-stack">
          
          {/* Deposit Chips Card */}
          <div className="wallet-box-card">
            <div className="card-header-black">{t.deposit}</div>
            <div className="card-description-box">
              {t.depositDesc}
            </div>
            <div className="card-inner-chip-box">
              <div className="chip-icon-badge">💵</div>
              <h3 className="chip-amount-val">₹{depositAmount}</h3>
              <span className="chip-sub-label">{t.chipsLabel}</span>
            </div>
            <Link to="/addcase" className="card-footer-btn btn-black-action">
              {t.add}
            </Link>
          </div>

          {/* Winning Chips Card */}
          <div className="wallet-box-card mb-5">
            <div className="card-header-black">{t.winnings}</div>
            <div className="card-description-box">
              {t.winningDesc}
            </div>
            <div className="card-inner-chip-box">
              <div className="chip-icon-badge">💵</div>
              <h3 className="chip-amount-val">₹{winningAmount}</h3>
              <span className="chip-sub-label">{t.winningCashLabel}</span>
            </div>
            <Link to="/Withdrawopt" className="card-footer-btn btn-black-action">
              {t.withdraw}
            </Link>
          </div>

        </div>

      </div>

      {/* Right Sidebar Container */}
      <div className="wallet-sidebar-container mobile-hide">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Mywallet;